import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { BaseCustomerPreferences } from "src/common/types/customerPrefs";
import initialState from "../store/initialState";

export default function internalBranchReasonsReducer(
  state: BaseCustomerPreferences = initialState.defaultCustomerPrefs,
  action: AnyAction
): BaseCustomerPreferences {
  switch (action.type) {
    case internalActionKeys.GET_DEFAULT_CUST_PREFS_SUCCESS:
      return action.defaultCustomerPrefs;
    case internalActionKeys.GET_DEFAULT_CUST_PREFS_FAILURE:
      return state;
    case internalActionKeys.PATCH_DEFAULT_CUST_PREFS_SUCCESS:
      return action.defaultCustomerPrefs;
    case internalActionKeys.PATCH_CATEGORY_FAILURE:
      return state;
    default:
      return state;
  }
}
